import { Market } from 'api/general/models';
import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';

type GetParams = {
  market: string;
};

export const getAdminMarketNeighborhoods = actionsFactories.createGetManyActionsFactory<
  EntityType<Market>,
  GetParams
>()(
  'GET_ADMIN_NEIGHBORHOODS_REQUEST',
  'GET_ADMIN_NEIGHBORHOODS_SUCCESS',
  'GET_ADMIN_NEIGHBORHOODS_FAILURE',
  'GET_ADMIN_NEIGHBORHOODS_RESET',
);
